import { FunctionComponent } from 'react'
import { Box } from '@black-bear-energy/rucksack'
import { FieldLabel } from './FieldLabel'
import { FieldValue } from './FieldValue'

export const Field: FunctionComponent<FieldProps> = ({
  label,
  children,
  variant = 'vertical',
  isPending = false,
}) => {
  /** If false, the variant is 'horizontal'. */
  const isVertical = variant === 'vertical'

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isVertical ? 'column' : 'row',
        gap: isVertical ? '5px' : 1,
        alignItems: isVertical ? 'flex-start' : 'center',
      }}
    >
      <FieldLabel label={label} />
      <FieldValue isPending={isPending}>{children}</FieldValue>
    </Box>
  )
}

interface FieldProps {
  label: string
  children?: React.ReactNode
  variant?: 'vertical' | 'horizontal'
  isPending?: boolean
}
